import React, { createContext, useContext, useMemo } from 'react';
import { getChatThemeTokens, type IdigestChatTheme, type IdigestChatThemeTokens } from './theme';

export interface IdigestChatThemeContextValue {
  theme: IdigestChatTheme;
  tokens: IdigestChatThemeTokens;
}

const IdigestChatThemeContext = createContext<IdigestChatThemeContextValue>({
  theme: 'light',
  tokens: getChatThemeTokens('light')
});

export function IdigestChatThemeProvider({ theme, children }: { theme: IdigestChatTheme; children: React.ReactNode }) {
  const value = useMemo(
    () => ({
      theme,
      tokens: getChatThemeTokens(theme)
    }),
    [theme]
  );

  return <IdigestChatThemeContext.Provider value={value}>{children}</IdigestChatThemeContext.Provider>;
}

export function useIdigestChatTheme(): IdigestChatThemeContextValue {
  return useContext(IdigestChatThemeContext);
}
